(function () {

  const SECTION =
    '[data-section-id="template--22825523970328__80cd93df-e4f2-4f43-b2dd-49e03c87eb60"]';

  const CARD_SELECTOR =
    SECTION + ' .products-grid.collection-carousel .item-product.h_bd';


  function getProduct(card) {

    const raw =
      card.getAttribute('data-json-product');

    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw);
    } catch (error) {
      console.error('Finches product JSON error', error);
      return null;
    }
  }


  function isSoldOut(card) {

    const product = getProduct(card);

    if (!product) {
      return false;
    }

    if (product.available === false) {
      return true;
    }

    if (Array.isArray(product.variants)) {

      const available =
        product.variants.some(function (variant) {
          return variant.available;
        });

      return !available;
    }

    return false;
  }


  /*
   * Find the REAL hover Add To Bag button.
   *
   * Vinova has multiple .add-to-cart-btn elements inside
   * some product cards. The direct product-card form is
   * preferred over the popup button.
   */
  function getNativeAddButton(card) {

    /* Best match: Vinova direct color/add form */
    const directColorButton =
      card.querySelector(
        'form.one-option-color .add-to-cart-btn'
      );

    if (directColorButton) {
      return directColorButton;
    }


    /*
     * Otherwise find an Add To Cart button that is NOT
     * inside Vinova's popup variant interface.
     */
    const buttons =
      Array.from(
        card.querySelectorAll('.add-to-cart-btn')
      );


    const directButton =
      buttons.find(function (button) {

        return (
          !button.closest('.item-product__popup') &&
          !button.closest('.item-product__btn-add')
        );
      });


    if (directButton) {
      return directButton;
    }


    /*
     * Final fallback.
     */
    return buttons[0] || null;
  }


  function getQuickAdd(card) {

    return card.querySelector(
      '.btn-quick-add'
    );
  }


  /*
   * Find Vinova's existing SOLD OUT hover label and
   * hide only the deepest element containing exactly
   * "SOLD OUT".
   */
  function hideOriginalSoldOut(card) {

    const elements =
      Array.from(
        card.querySelectorAll('*')
      );


    elements.forEach(function (element) {

      if (
        element.classList.contains(
          'finches-permanent-add'
        )
      ) {
        return;
      }


      const text =
        (element.textContent || '')
          .trim()
          .replace(/\s+/g, ' ')
          .toUpperCase();


      if (text !== 'SOLD OUT') {
        return;
      }


      /*
       * Don't hide a large parent if one of its
       * children already contains the SOLD OUT text.
       */
      const childHasSoldOut =
        Array.from(element.children)
          .some(function (child) {

            return (
              (child.textContent || '')
                .trim()
                .replace(/\s+/g, ' ')
                .toUpperCase() === 'SOLD OUT'
            );
          });


      if (!childHasSoldOut) {

        element.classList.add(
          'finches-hide-theme-status'
        );
      }
    });
  }


  function updateButton(card, button) {

    if (isSoldOut(card)) {

      button.textContent =
        'SOLD OUT';

      button.disabled =
        true;

      button.classList.add(
        'is-sold-out'
      );

      hideOriginalSoldOut(card);

      return;
    }


    button.disabled =
      false;

    button.classList.remove(
      'is-sold-out'
    );

    button.textContent =
      'ADD TO BAG';
  }


  function setupCard(card) {

    /*
     * Remove accidental duplicates from previous runs.
     */
    const oldPermanent =
      card.querySelectorAll(
        ':scope > .finches-permanent-add'
      );


    oldPermanent.forEach(
      function (button, index) {

        if (index > 0) {
          button.remove();
        }
      }
    );


    let button =
      card.querySelector(
        ':scope > .finches-permanent-add'
      );


    if (!button) {

      button =
        document.createElement('button');

      button.type =
        'button';

      button.className =
        'finches-permanent-add';

      card.appendChild(button);


      button.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();


          if (isSoldOut(card)) {

            updateButton(
              card,
              button
            );

            return;
          }


          /*
           * Click the REAL Vinova product-card button.
           * This should preserve Vinova's normal
           * add-to-cart + cart popup behaviour.
           */
          const nativeButton =
            getNativeAddButton(card);


          if (nativeButton) {

            nativeButton.click();
            return;
          }


          /*
           * Product may require Vinova's option popup.
           */
          const quickAdd =
            getQuickAdd(card);


          if (quickAdd) {

            quickAdd.click();
            return;
          }


          console.warn(
            'Finches: no native Add To Cart action found',
            card
          );
        }
      );
    }


    updateButton(
      card,
      button
    );


    /*
     * Update after color/variant changes.
     */
    if (
      card.dataset.finchesBound !== '1'
    ) {

      card.dataset.finchesBound =
        '1';


      card.addEventListener(
        'change',
        function () {

          setTimeout(
            function () {

              updateButton(
                card,
                button
              );

            },
            50
          );
        }
      );
    }
  }


  function setupCards() {

    document
      .querySelectorAll(
        CARD_SELECTOR
      )
      .forEach(setupCard);
  }


  function init() {

    setupCards();

    /*
     * Slick finishes creating/cloning its slides
     * shortly after page load.
     *
     * These are finite calls, not a DOM observer.
     */
    setTimeout(
      setupCards,
      400
    );

    setTimeout(
      setupCards,
      1200
    );

    setTimeout(
      setupCards,
      2500
    );
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();
  }


  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(
        setupCards,
        100
      );
    }
  );

})();